import type { Thing } from 'schema-dts'
interface Faq {
	question: string
	answer: string
}

export const mapFaqsForJsonLd = (faqs: Faq[]): Thing[] => {
	return faqs.map(faq => {
		return {
			'@type': 'Question',
			'name': faq.question,
			'acceptedAnswer': {
				'@type': 'Answer',
				'text': faq.answer
			}
		}
	})
}
